module.exports = __webpack_public_path__ + "static/media/playPublic.fa60c853.svg";